// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/governance/ga4_writer_policy.yaml
// Regenerate: uv run python execution/generate_ga4_writer_policy.py

export const GA4_WRITER_POLICY_VERSION = 1 as const;
// prettier-ignore
const CLIENT_GA4_PROJECTIONS: Readonly<Record<string, string>> = {
  "commerce_add_to_cart": "add_to_cart"
};
// prettier-ignore
const OWNED_ONLY_CLIENT_EVENTS: ReadonlySet<string> = new Set([
  "commerce_checkout_started"
]);

export function clientGa4ProjectionFor(sourceEvent: string): string | undefined {
  return CLIENT_GA4_PROJECTIONS[sourceEvent];
}

export function isOwnedOnlyClientEvent(sourceEvent: string): boolean {
  return OWNED_ONLY_CLIENT_EVENTS.has(sourceEvent);
}
